define([
    "jquery",
    "underscore",
    "marionette",
    "views/withdrawal/common_view",
    "forms/withdrawal/credit_card_form"
], function ($, _, Marionette, CommonView, CreditCardForm) {
    return CommonView.extend({
        initialize: function () {
            this.bindUIElements();
            this.updateCurrency();
            this.form = new CreditCardForm();
        },

        events: _.extend(CommonView.prototype.events, {
            'change @ui.accountNoSelect': function (e) {
                this.updateCurrency();
            },
        }),

        updateCurrency: function () {
            var that = this;

            $.ajax({
                url: '/rest_withdrawal/get_mt4_account_currency',
                data: {
                    account_no: this.ui.accountNoSelect.val(),
                },
                success: function (data, res) {
                    that.ui.currencyAbbr.val(data);
                    that.updateWithdrawable();
                    that.updateFinancial();
                },
                error: function (data, error) {

                }
            })
        },

        updateWithdrawable: function () {
            var that = this;
            $.ajax({
                url: '/rest_withdrawal/get_credit_card_withdrawable',
                data: {
                    account_no: this.ui.accountNoSelect.val(),
                    currency_abbr: this.ui.currencyAbbr.val(),
                },
                success: function (data, res) {
                    $("#withdrawable_amount_cc").html(data + that.ui.currencyAbbr.val())
                },
                error: function (data, error) {

                }
            })
        }
    });
});
